import sw from 'stopword';
import SwalDialog from 'lib/utils/toast';

const isBlank = value => !value || !String(value).trim();

function getKeywords(text) {
  if (!text) {
    return [];
  }
  const rawText = text.replace(/[^a-zA-Z]+/gi, ' ').toLowerCase();
  return sw.removeStopwords(rawText.split(' ').filter(word => word.length >= 3));
}

function convertToTitleCase(text) {
  // SPICE, SALMON MAGIC => Spice, Salmon Magic
  if (!text) {
    return text;
  }
  const words = text.toLowerCase().split(' ');
  const convertedWords = words.map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
  return convertedWords.join(' ');
}

// Prefix a bare URL with https:// so it doesn't resolve against the app origin
// when used as an anchor href.
const normalizeUrl = url => {
  if (!url) {
    return url;
  }
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};

const handleCopyToClipboard = textToCopy => {
  navigator.clipboard
    .writeText(textToCopy)
    .then(() => {
      SwalDialog('success', 'Copied to clipboard', 'Success', 'center');
    })
    .catch(() => {
      SwalDialog('error', 'Failed to copy', 'Error', 'center');
    });
};

export { convertToTitleCase, getKeywords, handleCopyToClipboard, isBlank, normalizeUrl };
